"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <main className="grid" style={{ gap: "1rem", paddingTop: "2rem" }}>
      <section className="card">
        <h1>Beklenmeyen bir hata olustu</h1>
        <p className="muted">Lutfen tekrar deneyin.</p>
      </section>
      <button className="btn btn-primary" onClick={reset}>Tekrar Dene</button>
    </main>
  );
}
